import { Navigate } from "react-router-dom";
import { getLocalStorageItem } from "../Utils/Index"; 

const PlansGuard = ({ children }) => {
  let vendorId = null;
  try {
    const userDetail = JSON.parse(getLocalStorageItem("userDetail") || "{}");
    vendorId = userDetail?.vendorId;
  } catch {
    vendorId = null;
  }

  const hasVendorId = vendorId !== null && vendorId !== undefined && vendorId !== "";

  if (hasVendorId) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PlansGuard;